export const LABEL_PACKS_TYPES = [
    { name: 'instant', label: 'Instant', value: 'instant' },
    { name: 'regular', label: 'Regular', value: 'regular' }
]